export const UPPERCASE_EXCLUDED_FIELD_NAMES = [
  // Add field names here to keep specific inputs in normal case.
  // Example: 'email', 'remarks'
];

export const UPPERCASE_EXCLUDED_FIELD_IDS = [
  // Add element IDs here to keep specific inputs in normal case.
];

export const shouldAutoUppercaseField = (element) => {
  if (!element) return false;

  const tag = (element.tagName || '').toLowerCase();
  const type = (element.type || '').toLowerCase();
  const fieldName = (element.name || '').toLowerCase();
  const isSupportedInput = tag === 'textarea' || (tag === 'input' && ['text', 'search'].includes(type));
  if (!isSupportedInput) return false;
  if (fieldName.includes('password')) return false;

  if (element.readOnly || element.disabled) return false;
  if (element.dataset?.case === 'normal') return false;
  if (UPPERCASE_EXCLUDED_FIELD_NAMES.includes(element.name)) return false;
  if (UPPERCASE_EXCLUDED_FIELD_IDS.includes(element.id)) return false;

  return true;
};
